export function createElement(
    tagName: string,
    attributes: { [key: string]: string },
    innerContent?: string,
): HTMLElement {
    const element = document.createElement(tagName);

    for (const [key, value] of Object.entries(attributes)) {
        element.setAttribute(key, value);
    }
    if (innerContent) element.textContent = innerContent;

    return element;
}
